<i18n>
{
	"en": {
		"noChanges" : "No changes has been done to this setting",
		"user" : "Username",
		"oldValue": "Old value",
		"newValue": "New value",
		"changeDate": "Change Date",
		"cancelLabel": "Cancle"
	},
	"no": {
		"noChanges" : "Ingen endringer gjort med denne settingen",
		"user" : "Brukernavn",
		"oldValue": "Gammel verdi",
		"newValue": "Ny verdi",
		"changeDate": "Endret dato",
		"cancelLabel": "Lukk"
	}
}
</i18n>
<template>
	<t-dialog

		:isShown="isShown"
		:hasHeader="false"
		:cancelLabel="$t('cancelLabel')"
		@close="$emit('close')"
		@ok="$emit('close')"
		@cancel="$emit('close')"
	>
		<div clas="table">
			<t-grid
				v-if="systemSetting"
				ref="settingsHistoryGrid"
				:key="'settingsHistoryGridKey'"
				style="min-width:1173px;height:500px;"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:items="sortAndGet()"
			/>
			<t-no-content-panel v-else :text="$t('noChanges')" icon="history" />
		</div>
	</t-dialog>
</template>

<script>

import moment from 'moment';
import deepcopy from 'deepcopy';

export default {
	props:{
		isShown: Boolean,
		systemSetting: Object
	},
	data() {
		return {
			columnDefinitions: [
				{
					field: 'user',
					displayName: this.$t('user'),
					resizable: true,
					width: 150
				},
				{
					field: 'oldValue',
					displayName: this.$t('oldValue'),
					resizable: true,
					width: 430
				},
				{
					field: 'newValue',
					displayName: this.$t('newValue'),
					resizable: true,
					width: 430
				},
				{
					field: 'changeData',
					valueGetter: item =>  moment(item.changeDate).format('YYYY.MM.DD HH:mm'),
					displayName: this.$t('changeDate'),
					width: 150,
					resizable: false,
				},
			],
			defaultColumnDefinition: { resizable: true }
		};
	},
	methods: {
		sortAndGet() {
			let { logs } = deepcopy(this.systemSetting);
			return logs.sort((a,b) => b.changeDate - a.changeDate);
		},
	},
};
</script>

<style scoped>
.wrapper{
	width:1180px;
	text-align: center;
	overflow-y:hidden;
}

.table{
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0px 20px;
}
</style>